import React, { Component } from "react";
import styled, { css } from "styled-components";

const Text = styled.p`
  margin-bottom: 1rem;
  color: #012639;

  ${props =>
    props.poppins &&
    css`
      font-family: "Poppins", sans-serif;
    `}
    ${props =>
    props.endTitle &&
    css`
      font-size: 1.25rem;
    `};
`;

const H3 = styled.h3`
  margin-bottom: 0.5rem;
  font-size: 1rem;
  color: #012639;

  ${props =>
    props.poppins &&
    css`
      font-family: "Poppins", sans-serif;
    `}
`;

const TextContainer = styled.div`
  padding: 2rem 0 2rem 2rem;
  border-left: 1px solid #012639;

  @media (max-width: 1030px) {
    border: 0;
    padding: 1rem;
  }
`;

class TextBlock extends Component {
  render() {
    return (
      <TextContainer>
        <H3 poppins>What is the year 2038 problem?</H3>
        <Text>
          The majority of digital systems use a 32 bit integer (32 binary
          numbers) to store time on a device.
        </Text>
        <Text>
          On 19 January 2038 at 03:14:07 UTC, time will essentially
          <b> 'run out'</b> and reset back to December 13th, 1901.
        </Text>

        <H3 poppins>What will happen in 2038?</H3>
        <Text>Potentially quite a lot... but most likely? Nothing.</Text>
        <Text>
          There could be disruptions to a wide variety of devices across the
          planet, which in turn could be devastating to the economy, hospitals,
          banks and any future device running on 32 bit time.
        </Text>
        <H3 poppins> What can we do about it?</H3>
        <Text>
          We can switch to long data type to store time, so let's just hope
          everyone has clocked on by then.
        </Text>

        <Text poppins endTitle>
          TL; DR - Imagine Y2K but in the Year 2038.
        </Text>
      </TextContainer>
    );
  }
}

export default TextBlock;
